import { ReactNode } from 'react';
import { IconPound } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { DateField } from '../DateField/DateField';
import { TConditionalField } from '../refinancing.types';

import styles from './ConditionalField.module.css';

type TProps = {
  field: TConditionalField;
  fieldName: string;
  error?: string;
  disabled?: boolean;
};

export const ConditionalField = ({
  field,
  fieldName,
  error,
  disabled,
}: TProps) => {
  const { register } = useFormContext();
  const { name, optional } = field;

  const label = (text: ReactNode): ReactNode =>
    optional ? (
      <>
        {text} <span className={styles.optional}>(optional)</span>
      </>
    ) : (
      text
    );

  switch (name) {
    case 'creditLimit':
      return (
        <Input
          // shouldUnregister drops the value from form state when this field
          // unmounts (e.g. the facility type changes) so we don't submit stale
          // conditional fields.
          {...register(`${fieldName}.creditLimit`, { shouldUnregister: true })}
          label={label('Credit limit')}
          iconLeft={<IconPound />}
          type="text"
          error={error}
          disabled={disabled}
        />
      );
    case 'monthlyRepayment':
      return (
        <Input
          {...register(`${fieldName}.monthlyRepayment`, {
            shouldUnregister: true,
          })}
          label={label('Monthly repayment')}
          iconLeft={<IconPound />}
          type="text"
          error={error}
          disabled={disabled}
        />
      );
    case 'lastRepaymentDate':
      return <DateField fieldName={fieldName} label={label} error={error} />;
  }
};
